export enum BillTypeEnum {
  C = 'درخواست هزینه',
  O = 'معوقه',
  D = 'تعدیلات الکترونیک',
  d = 'تعدیلات پیش پذیرش',
  c = 'پیش پذیرش',
  N = 'نظارتی',
  A = 'اسنادی',
}
